<script>
	import { onMount,onDestroy } from 'svelte'
	import DatePicker from './DatePicker.svelte'

	export let onSelect = function(date) {}
	export let onDeSelect = function(date) {}
  	export let availableDates = null
	export let dateFormat = 'YYYY-MM-DD'
	export let customclass = ''
	export let title = ''
	export let locale;
	export let showAllFutureDates;
	export let calendarLocation;


	

	let cmpDatePicker;
	
	function datepicked (e) {
		onSelect.call(e, e.detail.datepicked);
	}
	function dateUnPicked (e) {
		onDeSelect.call(e, e.detail.datepicked);
	}
	
</script>

<DatePicker bind:this={cmpDatePicker} on:datepicked={datepicked} on:dateUnPicked={dateUnPicked} availableDates={availableDates} dateFormat={dateFormat} customclass={customclass} title={title} locale={locale} {showAllFutureDates} {calendarLocation}/>

<!-- <svelte:head>
	<link href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css" rel="stylesheet">
</svelte:head> -->